import { useSpring, animated } from 'react-spring'

export default function Counter({ limit, duration }: { limit: number; duration?: number }) {
  const { number } = useSpring({
    from: { number: 0 },
    to: { number: limit },
    config: {
      duration: duration ?? 3000,
      easing: (t) => 1 - (1 - t) ** 3 // ease-out function
    }
  })

  return <animated.span>{number.interpolate((num) => Math.floor(num))}</animated.span>
}
